import { automationTherapistResponse } from '@/modules/permissionsToogle/domain/models/automationTherapistResponse'

import { axios, Response } from '..'

const updatePermissionManual = (
  automationGroupManualId: string
): Response<automationTherapistResponse> => {
  return axios.put(`/v1/automation-groups-manual/${automationGroupManualId}`)
}
export default updatePermissionManual
